import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Self,
  ChangeDetectionStrategy
} from '@angular/core';
import { CoverImageSize } from '../types';
import { PhotographerCoverServiceService } from '../photographer-cover-service.service';
import { ControlValueAccessor, NgControl } from '@angular/forms';

import { Subject } from 'rxjs';
import { AbstractValueAccessor } from '../../../core/form/FormControl';
import { TypedFormBuilder } from '../../form/TypedFormBuilder';
import { filter, tap } from 'rxjs/operators';

@Component({
    selector: 'lib-cover-view',
    templateUrl: './cover-editor-view.component.html',
    styleUrls: ['./cover-editor-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CoverEditorViewComponent
  extends AbstractValueAccessor
  implements ControlValueAccessor, OnInit
{
  @Input() @HostBinding('class.forceSquare') forceSquare = false;
  @Input() hasPhotos = true;
  @Input() size: CoverImageSize = null;
  @Input() coverType: 'public' | 'private' | 'booking' = 'public';
  stateChanges = new Subject<void>();
  defaultTabIndex: 0;
  @Input() context;
  @Input()
  publicSessionId;
  tabIndex: 0;
  model = this.fb.typedGroup<{
    file: string;
    size: {
      w: number;
      h: number;
    };
    point: { x: number; y: number };
    x: number;
    y: number;
  }>({
    y: [],
    x: [],
    point: [],
    file: [],
    size: [{}],
  });

  private _contextId;

  get contextId() {
    return this._contextId;
  }

  @Input() set contextId(value) {
    if (this._contextId !== null && this._contextId !== value) {
      this.model.reset();
    }
    this._contextId = value;
  }

  constructor(
    private service: PhotographerCoverServiceService,
    private fb: TypedFormBuilder,
    @Self() @Optional() public ngControl: NgControl,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  reset() {
    this.model.patchValue(null);
    this.writeValue(null);
  }

  ngOnInit(): void {
    let updateFromTopInProgress = false;
    this.subscribeWhileAlive(
      this.valueSubject.pipe(
        filter((value) => !!value && !!value.file),
        tap((current) => {
          updateFromTopInProgress = true;
          console.log(current);
          this.model.patchValue({
            ...current,
            x: current.point?.x ? current.point?.x : current.x,
            y: current.point?.y ? current.point?.y : current.y,
            point: {
              x: current.point?.x ? current.point?.x : current.x,
              y: current.point?.y ? current.point?.y : current.y,
            },
          });
          console.log('CURRENT MODEL VALUE', this.model.value);
          this.changeDetectorRef.detectChanges();
          updateFromTopInProgress = false;
        }),
      ),
      this.model.valueChanges.pipe(
        filter(({ file }) => !updateFromTopInProgress && !!file),
        tap(({ file, size, x, y }) => {
          if (!file) {
            this.writeValue(null);
          } else {
            this.writeValue({
              file,
              size,
              point: { x, y },
              x,
              y,
            });
          }
        }),
      ),
    );
  }

  saved(newData) {
    console.log('save data', newData);
    if (!!newData) {
      this.model.patchValue({
        ...newData,
        width: newData.size.w,
        height: newData.size.h,
        fileName: newData.file,
      });
    }
  }
}
